import React from 'react';
import { ICompanyCurrentOrdersResponce, IOrderResponse } from '../../../../../../../../Interfaces/responseTypes';
import CompanyOrderCard from '../Card/companyOrderCard';
import styles from './orderList.module.scss';

interface IProps {
  company_id: number;
  orders?: ICompanyCurrentOrdersResponce | IOrderResponse[];
  currencySymbol: string,
  selectOrder: (order: IOrderResponse) => void;
  onOpenStatusDialog: (order: IOrderResponse) => void;
}

const CompanyOrderList: React.FC<IProps> = ({ orders, currencySymbol, selectOrder, onOpenStatusDialog }) => {
  let allOrders: IOrderResponse[] = [];

  if (Array.isArray(orders)) {
    allOrders = orders;
  } else if (orders) {
    allOrders = [
      ...(orders.new_orders || []),
      ...(orders.pending_orders || []),
      ...(orders.accepted_orders || []),
      ...(orders.in_preparation_orders || []),
      ...(orders.ready_for_pickup_orders || []),
      ...(orders.out_for_delivery_orders || []),
    ];
  }

  return (
    <div className={styles.container}>
      {allOrders.map((order) => (
        <CompanyOrderCard
          key={order.id}
          order={order}
          currencySymbol={currencySymbol}
          isNew={!Array.isArray(orders) && orders?.new_orders?.includes(order)}
          onSelect={selectOrder}
          onOpenStatusDialog={onOpenStatusDialog}
        />
      ))}
    </div>
  );
};

export default CompanyOrderList;
